import { JOVE_ICON_SELECT_ICON_MAP } from '@jove-frontend/mui';
import { Bolt } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { RevealView, StaggerItemView, StaggerView } from '../../../portal/common/motion';
import { getDefaultDashboardLoginIntroInfo, getDefaultJoveLoginIntroInfo, getDefaultOrgLoginIntroInfo, getDefaultPortalLoginIntroInfo } from '../config';
import { PortalLoginSourceEnum, PortalLoginSystemSourceEnum } from '../types';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var resolveIntroDisplayInfo = function resolveIntroDisplayInfo(config) {
  var introInfo = config.introInfo,
      loginSource = config.loginSource,
      systemSource = config.systemSource;

  if (systemSource !== PortalLoginSystemSourceEnum.Cms) {
    return systemSource === PortalLoginSystemSourceEnum.Dashboard ? getDefaultDashboardLoginIntroInfo() : getDefaultJoveLoginIntroInfo();
  }

  if (loginSource === PortalLoginSourceEnum.Broker) {
    return introInfo || getDefaultPortalLoginIntroInfo();
  }

  return loginSource === PortalLoginSourceEnum.Org ? getDefaultOrgLoginIntroInfo() : getDefaultJoveLoginIntroInfo();
};

var LoginIntroPanel = function LoginIntroPanel(props) {
  var introInfo = props.introInfo,
      _props$loginSource = props.loginSource,
      loginSource = _props$loginSource === void 0 ? PortalLoginSourceEnum.Jove : _props$loginSource,
      _props$systemSource = props.systemSource,
      systemSource = _props$systemSource === void 0 ? PortalLoginSystemSourceEnum.Cms : _props$systemSource;
  var displayInfo = resolveIntroDisplayInfo({
    introInfo: introInfo,
    loginSource: loginSource,
    systemSource: systemSource
  });
  return /*#__PURE__*/_jsx(Box, {
    className: "flex w-full flex-col justify-center bg-[#EBEFFE] px-6 py-12 md:w-[46%] md:px-14 md:py-16",
    children: /*#__PURE__*/_jsxs(RevealView, {
      direction: "left",
      className: "mx-auto flex w-full max-w-[520px] flex-col space-y-10",
      children: [/*#__PURE__*/_jsx(Typography, {
        component: "h2",
        className: "text-3xl font-black leading-tight text-[#202020] md:text-[38px]",
        children: displayInfo.title
      }), /*#__PURE__*/_jsx(StaggerView, {
        className: "flex flex-col space-y-8",
        children: (displayInfo.introList || []).map(function (item, index) {
          var IconComponent = JOVE_ICON_SELECT_ICON_MAP[item === null || item === void 0 ? void 0 : item.iconName] || Bolt;
          return /*#__PURE__*/_jsxs(StaggerItemView, {
            className: "flex flex-row items-start space-x-4",
            children: [/*#__PURE__*/_jsx(Box, {
              className: "flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-white shadow-sm",
              children: /*#__PURE__*/_jsx(IconComponent, {
                className: "h-6 w-6 text-[#0E35D1]",
                fontSize: "small"
              })
            }), /*#__PURE__*/_jsxs(Box, {
              className: "flex flex-col",
              children: [/*#__PURE__*/_jsx(Typography, {
                className: "text-base font-bold text-[#202020]",
                children: item.title
              }), /*#__PURE__*/_jsx(Typography, {
                className: "text-base font-medium text-[#202020]",
                children: item.desc
              })]
            })]
          }, index);
        })
      })]
    })
  });
};

export default LoginIntroPanel;